import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {URL_ADMIN, URL_HQ, URL_HQ_SCHOOL_LECTURE_DETAIL} from 'routes/AdminRoute';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Flex,
  Input,
  Popconfirm,
  Row,
  Select,
  Space
} from 'antd';
import {BaseSection} from 'components/layouts';
import {AlertModal, BaseContainer, SearchDesc, SimpleModal} from 'components/containers';
import {BaseButton, BaseDatePicker, DataGrid, FillButton, ExcelButton} from 'components/elements';
import {GridSetting} from 'pages/common';
import {IconDownloadExcel, IconExclamation} from 'components/assets/icons';
import {getListAPI, postColUpdateAPI} from 'api/common';
import {fnSetColumn, getFormatDate, utilSearchData} from 'utils/utils';
import {storeSchoolTypeOptions, teacherGradeSearchOptions, teacherObserveOptions} from 'data/options';
import dayjs from 'dayjs';
import {getLocalStorage} from 'hooks/useLocalStorage';
import {exportStyleExcelDownload} from 'utils/file';
import {putAcademyCompleteDateAPI} from 'api/teacher';

const SchoolLecture = ({common}) => {
  const navigate = useNavigate();
  const menu = getLocalStorage('openMenuInfo')
  const [excelHeaders, setExcelHeaders] = useState([])
  const [colList, setColList] = useState({
    gridSettingList: [],
    gridList: []
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [dataList, setDataList] = useState([]);
  const [columnList, setColumnList] = useState([]);
  const [staticsList, setStaticsList] = useState([]);
  const [schoolData, setSchoolData] = useState({});
  const [searchData, setSearchData] = useState({
    teacher_employ_start_date: '',
    teacher_employ_end_date: '',
    observe_status: '-1', // 전체
    search_state: 'school_name', // 2: 교육원명
    search_content: '',
    teacher_grade: '-1' //전체
  });

  const [alertModal, setAlertModal] = useState({
    open: false,
    message: ''
  });

  const [memoData, setMemoData] = useState({
    teacher_idx: -1,
    memo: ''
  });
  const [memoModal, setMemoModal] = useState({
    open: false
  });

  const fnExcelDownload = () => {
    const processData = dataList?.map((item) => {
      let resist = '';
      if (item?.ACADEMY_REGIST_YN === '0') {
        resist = 'X';
      } else {
        resist = 'O';
      }
      const obj = {}
      colList?.gridList.forEach(it => {
        if ('ACADEMY_REGIST_YN' === it.dataIndex) {
          obj['ACADEMY_REGIST_YN'] = resist
        } else {
          obj[it.dataIndex] = item[it.dataIndex]
        }
      });
      return obj
    });

    const headerList = colList?.gridList.map(it => {
      if (it.dataIndex === 'ACADEMY_COMPLETE_DATE') {
        return '아카데미 교육 수료일'
      } else if (it.dataIndex === 'ACADEMY_REGIST_YN') {
        return '아카데미 등록 여부'
      } else {
        return it.title
      }
    })
    exportStyleExcelDownload(headerList, processData, menu?.depth?.[1]);
  };

  const fnCloseAlertModal = () => {
    setAlertModal({...alertModal, open: false, message: ''});
  };

  const fnUpdateCol = async (value, idx) => {
    try {
      const sendData = {};
      let checked = 0;
      if (value) {
        checked = 1;
      }

      sendData.idx = idx;
      sendData.table_name = 'TB_TEACHER';
      sendData.colum_name = 'ACADEMY_REGIST_YN';
      sendData.update_colum_data = checked;

      const {data} = await postColUpdateAPI(sendData);
      if (data?.responseCode === 200) {
        setAlertModal({...alertModal, open: true, message: '변경되었습니다.'});
        fnGetList();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fnUpdateAcademyCompleteDate = async (value, record) => {
    //아카데미 교육 수료일
    if (window.confirm('변경하시겠습니까?')) {
      await putAcademyCompleteDateAPI({academy_complete_date: value, idx: record.IDX})
        .then((res) => {
          if (res.data?.responseCode === 200) {
            setAlertModal({...alertModal, open: true, message: '변경되었습니다.'});
            fnGetList();
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const fnGetList = async () => {
    try {
      // 공통 서치바 데이터 체크 및 데이터 리턴
      const result = utilSearchData(searchData);
      if (typeof result === 'string') {
        setAlertModal({...alertModal, open: true, message: result});
      } else {
        const {data} = await getListAPI(result);
        const {COLUMS_LIST, DATA_LIST, STATICS_LIST} = data;
        setExcelHeaders(fnSetColumn(COLUMS_LIST, columns))
        setColList({
          ...colList,
          gridSettingList: data?.COLUMS_LIST,
          gridList: fnSetColumn(data?.COLUMS_LIST, columns)
        });
        setColumnList(COLUMS_LIST);
        setDataList(DATA_LIST);
        setStaticsList(STATICS_LIST);
      }
    } catch (error) {
      setAlertModal({
        ...alertModal,
        open: true,
        message: '서버 통신오류입니다.'
      });
      console.error(error);
    } finally {
      // 추후 loading 로직 추가
    }
  };

  useEffect(() => {
    fnGetList();
  }, []);

  const searchItem = [
    {
      key: 1,
      label: '채용일',
      children: (
        <Space>
          <BaseDatePicker
            value={searchData?.teacher_employ_start_date}
            onChange={dateString => setSearchData({ ...searchData, teacher_employ_start_date: dateString })}
          />
          ~
          <BaseDatePicker
            value={searchData?.teacher_employ_end_date}
            onChange={dateString => setSearchData({ ...searchData, teacher_employ_end_date: dateString})}
          />
        </Space>
      )
    },
    // {
    //   key: 2,
    //   label: '참관상태',
    //   children: <Select placeholder="" style={{width: '12rem'}} options={teacherObserveOptions}
    //                     value={searchData?.observe_status}
    //                     onSelect={(v) => setSearchData({...searchData, observe_status: v})}/>
    // },
    {
      key: 3,
      label: '강사직급',
      children: <Select placeholder="" style={{width: '12rem'}} options={teacherGradeSearchOptions}
                        value={searchData?.teacher_grade}
                        onSelect={(v) => setSearchData({...searchData, teacher_grade: v})}/>
    },
    {
      key: 4,
      label: '검색조건',
      children: (
        <Space>
          <Select
            style={{width: '12rem'}}
            options={[
              {label: '교육원명', value: 'school_name'},
              {label: '강사명', value: 'teacher_name'},
              {label: '강사아이디', value: 'teacher_id'}
            ]}
            value={searchData?.search_state}
            onSelect={(v) =>
              setSearchData({
                ...searchData,
                search_state: v
              })
            }
          />
          <Input style={{width: '16rem'}} placeholder="" maxLength={13} value={searchData?.search_content}
                 onChange={(v) => setSearchData({...searchData, search_content: v.target.value})} onPressEnter={fnGetList}/>
          <FillButton label="검색하기" width="100px" backgroundColor="var(--color-gray03)" onClick={fnGetList}/>
        </Space>
      )
    }
  ];

  const items = (row) => [
    {
      key: '1',
      label: '교육원타입',
      children: storeSchoolTypeOptions.filter((it) => it.value === row?.SCHOOL_TYPE)[0]?.label
    },
    {
      key: '2',
      label: '회원수',
      children: <Space>{row?.MEMBER_CNT ? row?.MEMBER_CNT : 0}명</Space>
    },
    {
      key: '3',
      label: '채용된 강사 현황',
      children: (
        <Space>
          <Row>
            {`부원장수: `}
            {row?.SCHOOL_SUB_LEADER_CNT ? row?.SCHOOL_SUB_LEADER_CNT + ' 명, ' : '0 명, '}
            {`주임수: `}
            {row?.SCHOOL_SENIOR_TEACHER_CNT ? row?.SCHOOL_SENIOR_TEACHER_CNT + ' 명, ' : '0 명, '}
            {`강사수: `}
            {row?.TEACHER_CNT ? row?.TEACHER_CNT + ' 명' : '0 명'}
          </Row>
        </Space>
      )
    }
  ];

  const columns = [
    {
      title: '번호',
      align: 'center',
      dataIndex: 'IDX'
    },
    {
      title: '지사명',
      align: 'center',
      dataIndex: 'BRANCH_NAME'
    },
    {
      title: '교육원명',
      align: 'center',
      dataIndex: 'SCHOOL_NAME',
      render: (item, row, idx) => {
        return (
          <Flex justify="center" align="center">
            {item}
            <Popconfirm
              icon={false}
              okButtonProps={{style: {display: 'none'}}}
              cancelButtonProps={{
                style: {display: 'none'},
                className: `custom-cancel-className-0`
              }}
              description={
                <Descriptions
                  bordered
                  column={1}
                  size="small"
                  labelStyle={{width: '100px', verticalAlign: 'middle'}}
                  contentStyle={{
                    width: '300px',
                    textAlign: 'left',
                    verticalAlign: 'middle'
                  }}
                  items={items(row)}
                />
              }
            >
              <Button type="text" icon={<IconExclamation/>}/>
            </Popconfirm>
          </Flex>
        );
      }
    },
    {
      title: '강사명',
      align: 'center',
      dataIndex: 'TEACHER_NAME',
      render: (item, row, idx) => {
        let text = '';
        if (row?.TEACHER_STATUS === '1') {
          text = '재직중';
        } else if (row?.TEACHER_STATUS === '2') {
          text = '휴직중';
        } else if (row?.TEACHER_STATUS === '3') {
          text = '병가중';
        } else if (row?.TEACHER_STATUS === '4') {
          text = '퇴사';
        } else {
          text = '등록신청';
        }
        return (
          <Flex justify="center" align="center">
            <span className={'text-link'}
                  onClick={() => navigate(`${URL_ADMIN + URL_HQ}${URL_HQ_SCHOOL_LECTURE_DETAIL.replace(':no', row?.IDX)}`)}>
              {item}
            </span>
            <Popconfirm
              placement="rightTop"
              icon={false}
              okButtonProps={{style: {display: 'none'}}}
              cancelButtonProps={{
                style: {display: 'none'},
                className: `custom-cancel-className-${idx}`
              }}
              title={text}
            >
              <Button type="text" icon={<IconExclamation/>}/>
            </Popconfirm>
          </Flex>
        );
      }
    },
    {
      title: '휴대폰번호',
      align: 'center',
      dataIndex: 'CELL_PHONE'
    },
    {
      title: '교육신청일',
      align: 'center',
      dataIndex: 'EDU_PROPOSE_DATE'
    },
    {
      title: '강사아이디',
      align: 'center',
      dataIndex: 'TEACHER_ID'
    },
    {
      title: (
        <>
          아카데미
          <br/>
          교육 수료일
        </>
      ),
      align: 'center',
      dataIndex: 'ACADEMY_COMPLETE_DATE',
      render: (item, row, idx) =>
        item ? (
          getFormatDate(item)
        ) : row?.ACADEMY_REGIST_YN ? (
          <Flex justify="center" align="center">
            <BaseDatePicker value={item} placeholder="날짜선택" format={'YYYY-MM-DD'} suffixIcon={null}
                            style={{padding: '4px 6px', width: '85px'}}
                            onChange={(value) => fnUpdateAcademyCompleteDate(value, row)}/>
            {/* <FillButton label='저장' onClick={()=>fnUpdateAcademyCompleteDate(row)} width='35px' />  */}
          </Flex>
        ) : (
          <></>
        )
    },
    {
      title: (
        <>
          아카데미
          <br/>
          등록 여부
        </>
      ),
      align: 'center',
      dataIndex: 'ACADEMY_REGIST_YN',
      render: (item, row) => {
        return (
          <Flex justify="center" align="center">
            <Checkbox
              checked={item}
              onChange={(v) => {
                fnUpdateCol(v.target.checked, row?.IDX);
              }}
              disabled={row?.ACADEMY_COMPLETE_DATE ? true : false}
            />
          </Flex>
        );
      }
    },
    {
      title: '강사채용일',
      align: 'center',
      dataIndex: 'TEACHER_EMPLOY_DATE',
      render: (item, row) => (item ? getFormatDate(item) : '')
    },
    {
      title: (
        <>
          지사 점검일
          <br />
          강사 수업참관
        </>
      ),
      align: 'center',
      dataIndex: 'BRANCH_CHECK_DATE',
      // render: (item, row) =>
      //   item ? (
      //     <Row
      //       onClick={() => {
      //         setMemoData({
      //           ...memoData,
      //           memo: row?.OBSERVE_MEMO,
      //           teacher_idx: row?.IDX
      //         });
      //         setMemoModal({
      //           ...memoModal,
      //           open: true
      //         });
      //       }}
      //     >
      //       {item}
      //     </Row>
      //   ) : (
      //     ''
      //   )
    },
    {
      title: (
        <>
          지사 점검 기한
          <br />
          (채용 + 30일)
        </>
      ),
      align: 'center',
      dataIndex: 'BRANCH_CHECK_LIMIT'
    },
    {
      title: '점검여부',
      align: 'center',
      dataIndex: 'CHECK_YN'
    }
  ];

  return (
    <BaseSection>
      <Flex gap={'7px'}>
        <Col flex="auto">
          <SearchDesc stats={staticsList} items={searchItem} column={4} inline/>
        </Col>
      </Flex>
      <BaseContainer>
        <Col span={24}>
          <Flex justify={'space-between'}>
            <Row>
              <GridSetting colList={columnList} fnUpdateCol={fnGetList}/>
              <ExcelButton
                // label={'엑셀 다운로드(검색)'} //뷰네임 미입력시 기본값
                // isCheckComp={true} //체크박스 컴포넌트 여부 미입력시 X
                headerList={excelHeaders} //필수 헤더리스트 표 설정과 동일한 변수여야함
                gridList={dataList} //필수 실시간 그리드 데이터
                // filterList={[]} //뺄 칼럼 목록 dataIndex 미입력시 dataIndex 키 없는것만 뺌
                renderList={[
                  {
                    dataIndex: 'SCHOOL_NAME',
                    render: (item) => item
                  },
                  {
                    dataIndex: 'TEACHER_NAME',
                    render: (item) => item
                  },
                  {
                    dataIndex: 'ACADEMY_REGIST_YN',
                    render: (item) => item
                  },
                ]} //코드 or 다른이름으로 바꿔서 다운할 목록
                // checkRows={} //isCheckComp true 일시 checkRows 데이터 미입력시 체크작동안함
                // checkKey={} //isCheckComp true 일시 check 한 데이터 dataIndex 키 네임 미입력시 체크작동안함
                // fileName={} //파일네임 미입력시 해당 메뉴이름
              />
            </Row>
          </Flex>
          <Divider className="divider-small"/>
          <DataGrid rowKey={'IDX'} columns={excelHeaders} data={dataList} pagination
                    currentPage={currentPage} onChange={(value) => setCurrentPage(value)}/>
        </Col>
      </BaseContainer>
      <AlertModal open={alertModal?.open} onCancel={fnCloseAlertModal}>
        {alertModal?.message}
      </AlertModal>
      {/* <SimpleModal
        open={memoModal?.open}
        onClose={() => setMemoModal({...memoModal, open: false})}
        title="메모 삽입"
        width="600px"
        height="220px"
        footer={[
          <Flex justify="center">
            <FillButton label="등록" backgroundColor={'var(--color-gray03)'}/>
            <FillButton key={'close'} label="닫기" color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'}
                        onClick={() => setMemoModal({...memoModal, open: false})}/>
          </Flex>
        ]}
      >
        <Row>
          <Col span={24}>
            <Input.TextArea
              rows={6}
              style={{width: '60rem'}}
              placeholder="메모"
              maxLength={300}
              value={memoData?.memo}
              onChange={(e) => {
                setMemoData({
                  ...memoData,
                  memo: e.target.value
                });
              }}
            />
          </Col>
        </Row>
      </SimpleModal> */}
    </BaseSection>
  );
};

export default SchoolLecture;
